import { persist } from "zustand/middleware";
import { create } from "zustand";

// The API wraps each product in its own { products: [...] } envelope.
const normalizeProducts = (payload) => {
    const list = Array.isArray(payload) ? payload : (payload?.products ?? []);

    return list.flatMap((entry) => (
        Array.isArray(entry?.products) ? entry.products : [entry]
    ));
};

const useProductsStore = create(
    persist(
        (set) => ({
            products: [],
            setProducts: (products) => set({ products: normalizeProducts(products) }),
        }),
        {
            name: "products-storage",
            version: 3,
            migrate: () => ({ products: [] }),
        }
    )
);

export default useProductsStore;

// wut the API returns
// {
//   products: [
//     {
//       products: [
//         {
//           id: 14,
//           name: "Enhancement",
//           description: "...",
//           base_price: 10000,
//           base_duration: 30,
//           attributes: [{ attribute_id, name, required, values: [{ id, value, price, duration }] }]
//         }
//       ]
//     },
//     ...
//   ]
// }